// extracted by mini-css-extract-plugin
export default {"wrapper":"TransportEditModal_wrapper__iJbU+"};